import {NotFoundPage} from 'common';
import {ProviderOfferDetailPage} from "placement";
import React from 'react';
import {Helmet} from 'react-helmet';
import {Redirect, Switch} from 'react-router';
import {Route} from 'react-router-dom';
import {AzureAuthenticatedEnvironment} from "../security/component/azure/AzureAuthenticatedEnvironment";
import {AzurePortalSecuredRoute} from "../security/component/azure/AzurePortalSecuredRoute";
import {InternalPlacementSubmitOfferPage} from "../offer/component/InternalPlacementSubmitOfferPage";
import { SessionStoredPlacementPage } from 'placement/core/persistence/SessionStoredPlacementPage';
import { ProviderSelectionPage } from 'providerapp/ProviderSelectionPage';
import { useApplicationRootUrl } from 'common/component/ApplicationRootContext';

const PLACEMENT_TEAM = [
    'CLIENT_PLACEMENT_SPECIALIST',
    'CLIENT_PLACEMENT_DECISION_MAKER',
] as const;

const PROVIDER_SUPPORT_TEAM = [
    'PROVIDER_SUPPORT',
] as const;

export const ClientPlacementAppAzure = () => {
    return (
        <AzureAuthenticatedEnvironment>
            <ClientPlacementApp/>
        </AzureAuthenticatedEnvironment>
    );
}

const ClientPlacementApp = () => {
    const rootUrl = useApplicationRootUrl();

    return (<>
        <Helmet>
            <meta
                name="description"
                content="Client Placement - The Catalight Care Services Provider Portal"
            />
            <title>Client Placement - The Catalight Care Services Provider Portal</title>
        </Helmet>
        <Switch>
            <AzurePortalSecuredRoute allowedRoles={PROVIDER_SUPPORT_TEAM} path={`${rootUrl}/select-provider`}
                                     render={() => <ProviderSelectionPage/>}/>
            <AzurePortalSecuredRoute allowedRoles={PLACEMENT_TEAM} path={`${rootUrl}/provider-offers-detail/:id`}
                                     render={() => <ProviderOfferDetailPage/>}/>
            <AzurePortalSecuredRoute allowedRoles={PLACEMENT_TEAM} path={`${rootUrl}/placement`}
                                     render={() => <SessionStoredPlacementPage />}/>
            <AzurePortalSecuredRoute allowedRoles={PLACEMENT_TEAM} path={`${rootUrl}`} exact
                                     render={() => <Redirect to={`${rootUrl}/placement`}/>}/>
            <AzurePortalSecuredRoute allowedRoles={PLACEMENT_TEAM} path={`${rootUrl}/submit-offer/:id`}
                                     render={() => <InternalPlacementSubmitOfferPage/>}/>
            <Route path='*' component={NotFoundPage}/>
        </Switch>

    </>)
}
